module.exports = __webpack_public_path__ + "static/media/01 Resolver win21 Cover_Interactive_001.51ed3974.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/01 Resolver win21 Cover_Interactive_001.jpg
// module id = 1292
// module chunks = 1